// Mappa unica: nome componente React → id del container DOM e fileName del bundle.
// Per cambiare widget di build basta modificare `const ActiveWidget = ...` in src/main.jsx;
// vite.config.js e index.html derivano tutto da qui.
export const WIDGET_IDS = {
  AppInstantQuote: 'instantquote',
  AppContactForm: 'form',
  AppContactFormInterpreting: 'formInterpreting',
  AppGiveUsACallModal: 'giveUsACallModal',
  AppLogin: 'login',
  AppLoginMobile: 'loginMobile',
  AppMktgCookie: 'mktgcookie',
}
